<div class="form-field">
  <div class="form-field__label-row">
    <div class="form-field__label-container">
      <div class="form-field__label">
        {{ field().labelKey | translate }}
      </div>
    </div>
  </div>
  <div class="form-field__dropdown-wrapper">
    <div
      class="form-field__input-wrapper"
      [class.open]="isDropdownOpen()"
      (click)="toggleDropdown()"
    >
      <div class="form-field__input-content">
        <div class="form-field__input-text" [class.placeholder]="!field().value">
          @if (field().value) {
            {{ translationKey() | translate }}
          } @else {
            {{ field().placeholderKey | translate }}
          }
        </div>
      </div>
      <div class="form-field__input-icon" [class.rotated]="isDropdownOpen()">
        <img src="/public/svgs/chevron-down.svg" alt="Dropdown" />
      </div>
    </div>
    @if (isDropdownOpen()) {
      <div class="form-field__dropdown-menu" (click)="$event.stopPropagation()">
        @for (option of options(); track option.value) {
          <div
            class="form-field__dropdown-item"
            [class.selected]="field().value === option.value"
            (click)="onSelectionChange(option.value); $event.stopPropagation()"
          >
            {{
              'app.components.courseCreator.settings.mainInfo.' +
                field().id +
                '.options.' +
                option.translationKey | translate
            }}
          </div>
        }
      </div>
    }
  </div>
  @if (isOtherSelected()) {
    <div class="form-field__custom-input-wrapper">
      <input
        type="text"
        class="form-field__custom-input"
        [placeholder]="
          'app.components.courseCreator.settings.mainInfo.' +
            field().id +
            '.customPlaceholder' | translate
        "
        [value]="field().customValue || ''"
        (input)="onCustomValueInput($event)"
        (click)="$event.stopPropagation()"
      />
    </div>
  }
</div>

